// extracted by mini-css-extract-plugin
module.exports = {"mainHeading":"PostView-module--main-heading--28yOi","registerButton":"PostView-module--register-button--VwRWF"};